import { Observable } from 'rxjs';
import { SpendRepository } from '../domain/spend/repository';
import { Spend } from '../domain/spend/model';
import HttpClient from '../utils/http-client';

export class SpendRepositoryImplementation extends SpendRepository {
  private httpClient: HttpClient;

  constructor() {
    super();
    this.httpClient = new HttpClient("", "");
  }

  createSpend(spend: Partial<Spend>): Observable<Spend> {
    return this.httpClient.post('/spends', spend);
  }

  createSpendWithSupportDocument(spend: Partial<Spend>): Observable<any> {
    return this.httpClient.post('/spends/support-document', spend);
  }

  getSpend(id: number): Observable<any> {
    return this.httpClient.get(`/spends/${id}`);
  }

  getSpends(page: number, limit: number): Observable<any> {
    return this.httpClient.get(`/spends?page=${page}&limit=${limit}`);
  }

  updateSpend(id: number, spend: Partial<Spend>): Observable<Spend> {
    return this.httpClient.put(`/spends/${id}`, spend);
  }

  deleteSpend(id: number): Observable<void> {
    return this.httpClient.delete(`/spends/${id}`);
  }
}
